import React from "react";
import { showResizablePopupModal } from "@widgets/CommonModal";
import SYS_ADDINFO_REG_POP_01 from "@widgets/commonpopup/sys/SYS_ADDINFO_REG_POP_01";

// 부가항목 등록 팝업 공통 오프너
// - cd_menu/id_target 기준으로 동적 항목을 구성
// - rowData를 초기값으로 주입
// - 닫기 시 null, 확인 시 팝업 반환값을 그대로 반환
type OpenAddInfoRegPopupParams = {
  title?: string;
  cd_menu: string;
  id_target: string;
  rowData: any;
  width?: string;
  height?: string;
  rememberSizeKey?: string;
};

export const openAddInfoRegPopup = async ({
  title = "부가항목 도움창",
  cd_menu,
  id_target,
  rowData,
  width = "980px",
  height = "760px",
  rememberSizeKey,
}: OpenAddInfoRegPopupParams) => {
  const result = await showResizablePopupModal({
    title,
    children: (
      <SYS_ADDINFO_REG_POP_01
        cd_menu={cd_menu}
        id_target={id_target}
        rowData={rowData}
      />
    ),
    validation: true,
    width,
    height,
    rememberSize: true,
    rememberSizeKey: rememberSizeKey ?? `SYS_ADDINFO_REG_POP_01:${cd_menu}:${id_target}`,
  });

  if (!result || result === "close") return null;
  return result;
};
